import classNames from 'classnames'
import { Ring2 } from 'ldrs/react'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { Body2 } from '@ui/Typography/Typography'
import { IconButton } from '@ui/components/Button'
import { createFileData } from '@ui/components/FileUpload/FileUpload'
import { FileData } from '@ui/components/FileUpload/types'
import { AlertIcon } from '@ui/icons/Alert.icon'
import { CloseIcon } from '@ui/icons/Close.icon'
import { TrashIcon } from '@ui/icons/Trash.icon'

import styles from './FileUpload.module.scss'

interface FileUploadResultProps {
  title?: string
  file: FileData
  error?: string
  disabled?: boolean
  isLoading?: boolean
  onUpload(data: FileData): void
  onRemove?(): void
}
export const FileUploadResult: React.FC<FileUploadResultProps> = (props) => {
  const { file, error, disabled, onUpload, onRemove, isLoading } = props
  const { t } = useTranslation()

  const hiddenFileInput = useRef<HTMLInputElement | null>(null)

  const handleUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const [newFile] = event.target.files || []
    if (!newFile) return

    const newFileData = createFileData(newFile)

    if (file.id) {
      newFileData.id = file.id
    }

    onUpload(newFileData)
    event.target.value = ''
  }
  const handleRetry = (e: React.FormEvent<HTMLElement>) => {
    e.preventDefault()
    if (hiddenFileInput.current) {
      hiddenFileInput.current.value = ''
      hiddenFileInput.current.click()
    }
  }

  return (
    <>
      <div
        className={classNames(styles.itemUploadWrapper, {
          [styles.itemUploadError]: error && !isLoading,
        })}
      >
        <Body2>{file.fileName}</Body2>

        <div className={styles.fileActions}>
          {isLoading && (
            <>
              <div>
                <Ring2
                  stroke='4'
                  strokeLength='0.25'
                  bgOpacity='0.1'
                  speed={'0.8'}
                  size={32}
                  color='#6145D9'
                />
              </div>
              <IconButton
                icon={{ icon: CloseIcon, color: 'text-med-em' }}
                onClick={onRemove}
                disabled={disabled}
              />
            </>
          )}

          {error && !isLoading && (
            <div className={styles.errorState}>
              <button
                type='button'
                className={styles.tryAgainButton}
                onClick={handleRetry}
                disabled={disabled}
              >
                <Body2 medium>{t('Try again')}</Body2>
              </button>
              <AlertIcon color={'text-danger-med-em'} />
              <input
                ref={hiddenFileInput}
                type='file'
                onChange={handleUpload}
                className={styles.hiddenInput}
              />
            </div>
          )}

          {!error && !isLoading && (
            <IconButton.Ghost
              icon={{ icon: TrashIcon, color: 'text-med-em' }}
              onClick={onRemove}
              disabled={disabled}
              size='xl'
            />
          )}
        </div>
      </div>
    </>
  )
}
